export default __webpack_public_path__ + "static/media/cp_geo_et.383fca54.svg";